import fetch from '@/plugin/axios'

// 成长币列表
export function getGrowthCoinList (query) {
  return fetch({
    url: '/api/order/credit-bag/list',
    method: 'Post',
    data: query
  })
}

// 添加成长币信息
export function addGrowthCoin (query) {
  return fetch({
    url: '/api/order/credit-bag/add',
    method: 'Post',
    data: query
  })
}

// 获取成长币信息
export function getGrowthCoinDetail (id) {
  return fetch({
    url: '/api/order/credit-bag/info/' + id,
    method: 'Get'
  })
}

// 修改成长币信息
export function updateGrowthCoinDetail (id, query) {
  return fetch({
    url: '/api/order/credit-bag/update/' + id,
    method: 'Post',
    data: query
  })
}

// 删除成长币
export function delGrowthCoin (id) {
  return fetch({
    url: '/api/order/credit-bag/remove/' + id,
    method: 'Get'
  })
}
